<template>
    <div :class="`d-flex justify-content-${alignment} py-${py}`">
        <b-pagination
            v-bind="$attrs"
            v-on="$listeners"
            :total-rows="total"
            :per-page="perPage"
            class="mb-0 custom-style"
            hide-goto-end-buttons
            first-number
            last-number
        />
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        total: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        alignment: {
            type: String,
            required: false,
            default: 'center',
            validator(value) {
                return ['start', 'center', 'end'].includes(value)
            },
        },
        py: {
            type: [String, Number],
            required: false,
            default: 4,
            validator(value) {
                if (typeof value === 'string') {
                    value = Number(value)
                }
                return value >= 0 && value <= 5
            },
        },
    },
}
</script>
<style scoped>
::v-deep .custom-style > li.active > a,
.custom-style > li > a:hover {
    background: #d7fff7;
    border: 1px solid #a3a3a3;
    color: #009ada;
}
</style>
